<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 16 13`"
    :width="getWidth"
  >
    <path d="M16,5.99537394 L9.3384734,11.7933693 L9.3384734,8.33924441 C8.22821342,8.33924441 7.22077039,8.42559667 6.31611411,8.59830378 C5.41145783,8.76278674 4.58494335,9.02184352 3.83654588,9.37548188 C3.0881484,9.72912025 2.40144234,10.1773296 1.77640709,10.7201234 C1.15137184,11.254693 0.559242066,11.8920549 0,12.6322282 C0.222051997,11.5795373 0.542788959,10.5433102 0.962220509,9.52351581 C1.37342791,8.5119456 1.94088561,7.58468682 2.66461064,6.74171164 C3.38833567,5.89873647 4.29297838,5.1770783 5.37856592,4.5767155 C6.45592931,3.98457684 7.77588527,3.58159963 9.3384734,3.36777178 L9.3384734,0 L16,5.99537394 Z" />
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-send'

  export default {
    name: 'SvgIconSend',
    components: {},
    mixins: [ bem ],
    props: {
      height: {
        default: '13',
        type: String
      },
      width: {
        default: '16',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconSend.vue